import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConstructAPI } from "src/app/API/constructAPI";
import { RestApiService } from "src/app/API/restapi";
import { ALERT_TYPE } from "src/app/constants";
import { Enums } from "src/app/Shared/enums";
import { SharedService } from "src/app/Shared/shared-service.service";
import { FormJService } from "src/services/form-j.service";

@Component({
  selector: "app-upload-image",
  templateUrl: "./upload-image.component.html",
  styleUrls: ["./upload-image.component.scss"],
  standalone: false,
})
export class UploadImageComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private sharedService = inject(SharedService);
  protected enums = inject(Enums);
  private formJService = inject(FormJService);

  @Input() isSetDocument: boolean;
  @Input() isLoanDocument = false;
  @Input() isReserveGroupDocument = false;
  @Input() isCustomerAcctDocument = false;
  @Input() isStampedFormJ = false;
  @Input() isBlacklistDocument = false;

  @Input() supportingDocType: string;
  @Input() contactDocType: string;
  @Input() custAcctDocType: string;

  @Input() selectedCustomerId: number;
  @Input() contactId: number;
  @Input() setId: number;
  @Input() loanId: number;
  @Input() formJId: number;
  @Input() formJStampDate: Date;
  @Input() reserveGroupId: number;
  @Input() customerAcctId: number;
  @Input() blacklistId: number;

  @Input() isSingleType = true;

  disableSubmit = true;

  companyId: number;
  updateStampDate: Date;

  image: string;
  file: File;

  @Output() passEntry = new EventEmitter<any>();

  ngOnInit(): void {
    this.companyId = Number(sessionStorage.getItem("companyId"));
    if (this.isStampedFormJ) {
      this.updateStampDate =
        this.formJStampDate === undefined
          ? undefined
          : new Date(this.formJStampDate);
    }
  }

  handleFileInput(files: FileList) {
    this.disableSubmit = false;
    this.file = files.item(0);
  }

  async addImage(uploadType?: string) {
    this.disableSubmit = true;

    if (this.file == undefined) {
      this.sharedService.openAlert(
        "Please select 1 file before proceed!",
        ALERT_TYPE.DANGER,
      );
    } else {
      let url = "";

      if (uploadType != undefined)
        url = this.constructApi.getUploadApplicationForm(
          this.selectedCustomerId,
          uploadType,
        );
      else if (this.supportingDocType != undefined)
        url = this.constructApi.getUploadApplicationForm(
          this.selectedCustomerId,
          this.supportingDocType,
        );
      else if (this.contactId != undefined) {
        if (this.contactDocType != undefined)
          url = this.constructApi.getUploadContactTypedFile(
            this.selectedCustomerId,
            this.contactId,
            this.contactDocType,
          );
        else
          url = this.constructApi.getUploadContactGuarantorForm(
            this.selectedCustomerId,
            this.contactId,
          );
      } else if (this.isSetDocument) {
        url = this.constructApi.getUploadSetFile(this.setId);
      } else if (this.isLoanDocument) {
        url = this.constructApi.getUploadLoanTypedFile(
          this.selectedCustomerId,
          this.loanId,
          this.enums.PAYOUT_SLIP,
        );
      } else if (this.isBlacklistDocument) {
        url = this.constructApi.getUploadBlacklistFile(this.blacklistId);
      } else if (this.isStampedFormJ) {
        if (this.updateStampDate !== undefined)
          url = this.constructApi.getCustomerStampedFormJFile(
            this.selectedCustomerId,
            this.formJId,
          );
        else {
          this.sharedService.openAlert(
            "Please select stamp date before proceed!",
            ALERT_TYPE.DANGER,
          );
          this.disableSubmit = false;
        }
      } else if (this.isReserveGroupDocument) {
        url = this.constructApi.getUploadReserveGroupFile(this.reserveGroupId);
      } else if (this.isCustomerAcctDocument) {
        if (this.custAcctDocType != undefined)
          url = this.constructApi.getUploadCustomerAcctTypedFile(
            this.selectedCustomerId,
            this.customerAcctId,
            this.custAcctDocType,
          );
        else
          url = this.constructApi.getUploadCustomerAcctFile(
            this.selectedCustomerId,
            this.customerAcctId,
          );
      } else url = this.constructApi.getUploadFile(this.selectedCustomerId);

      if (url.length > 0) {
        try {
          this.restApi.postFile(url, this.file).subscribe({
            next: async (res) => {
              if (this.isStampedFormJ) {
                await this.formJService.postStampFormJ(
                  this.formJId,
                  this.updateStampDate,
                );
                this.passEntry.emit(this.updateStampDate);
              } else if (this.loanId != undefined)
                this.passEntry.emit(this.loanId);
              else this.passEntry.emit(this.selectedCustomerId);

              this.sharedService.openAlert("Done Upload", ALERT_TYPE.SUCCESS);
              this.file = undefined;

              if (this.isSingleType == true) {
                this.reset();
              }
            },
            error: (err) => {
              this.restApi.handleError(err);
            },
          });
        } finally {
          // this.disableSubmit = false;
        }
      }
    }
  }

  reset() {
    this.file = undefined;
    this.activeModal.close(true);
  }
}
